(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { hexToRgbA } from "../../utils/hexToRgbA";
export const baseStyles = {
  control: {
    border: "none",
    borderLeft: "none",
    height: "100%",
    boxShadow: "none",
    "&:hover": {
      borderColor: "none"
    },
    borderRadius: "4px"
  },
  menu: {
    margin: 0,
    boxShadow: "0 0 20px #2028601A"
  },
  valueContainer: {
    paddingLeft: 20,
    marginTop: 15,
    fontSize: 15
  }
};
const _default = {
  control: base => ({ // none of react-select's styles are passed to <Control />
    ...base,
    ...baseStyles.control
  }),
  menu: base => ({ ...base,
    ...baseStyles.menu
  }),
  indicatorSeparator: base => ({ ...base,
    display: "none"
  }),
  valueContainer: base => ({ ...base,
    ...baseStyles.valueContainer
  }),
  singleValue: (base, state) => ({ ...base,
    display: state.selectProps.menuIsOpen ? "none" : "block",
    margin: 0
  }),
  option: (base, _ref) => {
    let {
      isSelected
    } = _ref;
    return { ...base,
      padding: "8px 20px",
      backgroundColor: isSelected ? "#132333" : "#ffffff",
      color: isSelected ? "#ffffff" : "#132333",
      ":selected": {
        backgroundColor: "#132333",
        color: "#ffffff"
      },
      ":active": {
        backgroundColor: "#132333",
        color: "#ffffff"
      },
      ":hover": {
        backgroundColor: hexToRgbA("#132333", 0.5),
        color: "#ffffff"
      }
    };
  }
};
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(baseStyles, "baseStyles", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/Select/styles.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/Select/styles.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();